/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi__pois__see_all = /** @type {(inputs: {}) => string} */ () => {
	return `Mehr anzeigen`
};

const en_zoi__pois__see_all = /** @type {(inputs: {}) => string} */ () => {
	return `See more`
};

const es_zoi__pois__see_all = /** @type {(inputs: {}) => string} */ () => {
	return `Ver más`
};

const fr_zoi__pois__see_all = /** @type {(inputs: {}) => string} */ () => {
	return `Voir plus`
};

const it_zoi__pois__see_all = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi altro`
};

const nl_zoi__pois__see_all = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijk meer`
};

const pt_zoi__pois__see_all = /** @type {(inputs: {}) => string} */ () => {
	return `Ver mais`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois__see_all = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi__pois__see_all(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi__pois__see_all", locale)
	if (locale === "de") return de_zoi__pois__see_all(inputs)
	if (locale === "en") return en_zoi__pois__see_all(inputs)
	if (locale === "es") return es_zoi__pois__see_all(inputs)
	if (locale === "fr") return fr_zoi__pois__see_all(inputs)
	if (locale === "it") return it_zoi__pois__see_all(inputs)
	if (locale === "nl") return nl_zoi__pois__see_all(inputs)
	return pt_zoi__pois__see_all(inputs)
};